import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../App';
import { LANGUAGES } from '../translations';

function Header() {
  const { language, setLanguage, t, linkPrefix } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const currentLang = LANGUAGES.find(l => l.code === language);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <Link to={linkPrefix || '/'} className="logo">
          <span className="logo-icon">👨‍🍳</span>
          <span>Chefyz</span>
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to={linkPrefix || '/'} className={`nav-link ${location.pathname === (linkPrefix || '/') ? 'active' : ''}`}>
            {t.nav.home}
          </Link>
          <Link to={`${linkPrefix}/privacy`} className={`nav-link ${location.pathname === `${linkPrefix}/privacy` ? 'active' : ''}`}>
            {t.nav.privacy}
          </Link>
          <Link to={`${linkPrefix}/terms`} className={`nav-link ${location.pathname === `${linkPrefix}/terms` ? 'active' : ''}`}>
            {t.nav.terms}
          </Link>
          <Link to={`${linkPrefix}/support`} className={`nav-link ${location.pathname === `${linkPrefix}/support` ? 'active' : ''}`}>
            {t.nav.support}
          </Link>

          <div className="language-selector">
            <button
              className="language-btn"
              onClick={() => setIsLangDropdownOpen(!isLangDropdownOpen)}
            >
              <span>{currentLang?.flag}</span>
              <span>{currentLang?.code.toUpperCase()}</span>
              <span>▼</span>
            </button>
            {isLangDropdownOpen && (
              <div className="language-dropdown">
                {LANGUAGES.map(lang => (
                  <div
                    key={lang.code}
                    className={`language-option ${language === lang.code ? 'active' : ''}`}
                    onClick={() => {
                      setLanguage(lang.code);
                      setIsLangDropdownOpen(false);
                    }}
                  >
                    <span>{lang.flag}</span>
                    <span>{lang.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </nav>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>
    </header>
  );
}

export default Header;
